import { useTranslation } from 'next-i18next';
import { clsx } from 'clsx';

// Interface
// ******************************************
export interface EmptyJobListProps {
  title?: string;
  className?: string;
}

/**
 * @description EmptyJobList Component. A component to be displayed when no jobs are found.
 *
 * - **title**: string - the title of the job list, containing the current filter labels.
 * - **className**: string - additional CSS classes to apply for styling purposes.
 */
export const EmptyJobList = (props: EmptyJobListProps) => {
  // Destructure props
  const { title, className } = props;

  // Translation
  const { t } = useTranslation('common');

  // Render component
  // *****************************************************
  return (
    <div className={clsx('mb-6 space-y-4', className)}>
      <div className="rounded-2xl border p-8 text-center">
        <p className="mb-0 font-semibold leading-loose">
          { t('job.list.no_result.title') }
        </p>
        {title && (<p>{title}</p>)}
      </div>
      <div className="rounded-2xl border p-8 text-center">
        <div className="mb-4">
          { t('job.list.recommendation.search') }
        </div>
        <ul className="space-y-0.5 text-sm text-ink-medium">
          <li>{ t('job.list.correct.keyword') }</li>
          <li>{ t('job.list.general.keyword') }</li>
        </ul>
      </div>
    </div>
  );
};

